/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography, Divider, Button, Popover } from "@mui/material";
import React, { useState, useEffect, useRef, useCallback } from "react";
import qs from "query-string";
import LoadingSpinner from "../../components/Composables/CircularProgressBar";
import CountInfo from "../../components/Composables/TilesCountInfo";
import API from "../../Utils/Interceptor/ApiMiddleware";
import DynamicDataGrid from "../../components/Composables/DynamicDataGrid";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
// import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { useNavigate, useLocation } from "react-router-dom";
import AddCandidatePop from "../../components/Composables/AddCandidatePop";
import formatters from "../../components/Composables/DataGridFormatters";
import DynamicForm from "../../components/Composables/DynamicForm";
import { debounce } from "lodash";
import AddToJob from "../../components/Composables/AddToJob";
import CustomSnackbar from "../../components/Composables/CustomSnackBarMenu";
import AddBulkCandidates from "./AddBulkCandidates";

function Candidates({
  pollStatus,
  setUploadProgress,
  setUploadingFiles,
  setUploadPanelOpen,
  setProcessedFiles,
  isProcessing,
  setIsProcessing,
}) {
  const [formState, setFormState] = useState({
    source: null,
    name: null,
    email: null,
    city: null,
    state: null,
    zip: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [addTOJob, setAddToJob] = useState(false);
  const [selectedCandidateIds, setSelectedCandidateIds] = useState([]);
  const [selectionError, setSelectionError] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({
    source: null,
    name: null,
    email: null,
    city: null,
    state: null,
    zip: null,
  });
  const [tempFormState, setTempFormState] = useState(formState);
  const location = useLocation();
  const [loading, setLoading] = useState({
    count: false,
    grid: false,
  });
  // const [openDialog, setOpenDialog] = useState({
  //   candidateCreate: false,
  //   filter: false,
  // });
  const debounceTimeout = useRef(null);
  const latestInputValue = useRef("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [formConfigurations, setFormConfigurations] = useState([
    {
      label: "Source",
      type: "autocomplete-multiple",
      name: "source",
      options: [],
      text: "Source",
    },
    {
      label: "Name of the Candidate",
      type: "autocomplete-multiple",
      name: "name",
      options: [],
      text: "Name",
    },
    {
      label: "Email of the Candidate",
      type: "autocomplete-multiple",
      name: "email",
      options: [],
      text: "Email",
    },
    // {
    //   label: "City",
    //   type: "autocomplete-multiple",
    //   name: "city",
    //   options: [],
    //   text: "City",
    // },
    // {
    //   label: "State",
    //   type: "autocomplete-multiple",
    //   name: "state",
    //   options: [],
    //   text: "State",
    // },
    // {
    //   label: "Zip",
    //   type: "autocomplete-multiple",
    //   name: "zip",
    //   options: [],
    //   text: "Zip",
    // },
  ]);
  const [candidatesData, setCandidatesData] = useState({
    countData: [],
    listData: [],
    paginationModel: {
      pageSize: 25,
      page: 0,
    },
    showAllData: false,
  });
  const navigate = useNavigate();

  const handleRowSelection = (row) => {
    navigate(`/candidates-description/${row.id}`, {
      state: {
        id: row.id,
      },
    });
  };
  const handleSelectionChange = (newSelectionModel) => {
    const currentPageIds = candidatesData.listData.candidateDetails.map(
      (c) => c.id
    );
    const newSelectedSet = new Set(selectedCandidateIds);

    currentPageIds.forEach((id) => {
      if (!newSelectionModel.includes(id)) {
        newSelectedSet.delete(id);
      }
    });

    newSelectionModel.forEach((id) => {
      if (newSelectedSet.size < 10 || newSelectedSet.has(id)) {
        newSelectedSet.add(id);
      }
    });

    if (newSelectionModel.length > 10) {
      setSelectionError("A maximum of 10 candidates can be selected.");
      return;
    } else {
      setSelectionError("");
    }

    setSelectedCandidateIds([...newSelectedSet]);
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  // const closeAddToJob = () => {
  //   setAddToJob(false);
  //   setSelectedCandidateIds([]);
  // };
  const handleChange = (key, value, inputValue = null) => {
    setTempFormState((prev) => ({
      ...prev,
      [key]: value,
      [`${key}Input`]: inputValue !== null ? inputValue : prev[`${key}Input`],
    }));

    if (inputValue !== null) {
      latestInputValue.current = inputValue;
      clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(() => {
        fetchCandidateFilterData({
          [`${key}Search`]: latestInputValue.current,
        });
      }, 1000);
    }
  };
  const handleResetFilters = async () => {
    const resetFilters = {
      source: null,
      name: null,
      email: null,
      city: null,
      state: null,
      zip: null,
    };
    setFormState(resetFilters);
    setCandidatesData((prevState) => ({
      ...prevState,
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    }));
    const query = qs.stringify(
      {
        ...resetFilters,
        page: 1,
      },
      { skipNull: true, skipEmptyString: true }
    );
    navigate(`/candidates?${query}`);

    handleClose();
  };
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setTempFormState(formState);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const clearSelectedCandidateIds = () => {
    setSelectedCandidateIds([]);
    setSelectionError("");
  };

  const fetchCandidateFilterData = async (filterParams) => {
    try {
      const response = await API.get(
        "/candidate/get-candidate-filter-details",
        {
          params: filterParams,
        }
      );

      if (response) {
        const apiData = response.data.data;
        setFormConfigurations((prevConfig) =>
          prevConfig.map((config) => {
            if (apiData.length > 0 && apiData[0].hasOwnProperty(config.name)) {
              const newOptions = apiData
                .map((item) => item[config.name])
                .filter((val) => val && val.trim() !== "")
                .map((val) => ({
                  value: val,
                  label: val,
                }));

              const mergedOptions = [
                ...newOptions,
                ...(config.options || []),
              ].reduce((acc, option) => {
                if (!acc.find((o) => o.value === option.value)) {
                  acc.push(option);
                }
                return acc;
              }, []);

              return { ...config, options: mergedOptions };
            }
            return config;
          })
        );
      }
    } catch (error) {
      console.error("Error fetching filter data:", error);
    }
  };

  const debouncedFetchCandidateFilterData = debounce(
    fetchCandidateFilterData,
    500
  );

  // useEffect(() => {
  //   const hasValidFilters = Object.values(formState).some(
  //     (value) => value !== null && value !== undefined && value !== ""
  //   );

  //   if (openDialog.filter && hasValidFilters) {
  //     // Find the currently active search field (nameSearch, emailSearch, etc.)
  //     const activeSearchField = Object.keys(formState).find(
  //       (key) => formState[key] && key.includes("Search")
  //     );

  //     // Call the function with the active search field
  //     if (activeSearchField) {
  //       debouncedFetchCandidateFilterData(activeSearchField);
  //     }
  //   }
  // }, [openDialog.filter, formState]);

  const fetchCandidatesGridData = useCallback(async () => {
    const payload = {
      filterFullName: appliedFilters.name,
      filterSource: appliedFilters.source,
      filterEmail: appliedFilters.email,
      filterCity: appliedFilters.city,
      filterState: appliedFilters.state,
      filterZip: appliedFilters.zip,
      filterGlobalSearch: null,
      pageSize: candidatesData.paginationModel.pageSize,
      page: candidatesData.paginationModel.page + 1,
    };
    setLoading((prev) => ({
      ...prev,
      grid: true,
    }));
    try {
      const response = await API.post(
        "/candidate/get-candidate-details",
        payload
      );
      const apiData = response?.data?.data;
      setCandidatesData((prevState) => ({
        ...prevState,
        listData: apiData,
        showAllData: true,
      }));
      handleClose();
    } catch (error) {
      console.error("Error fetching candidates grid data:", error);
    } finally {
      setLoading((prev) => ({
        ...prev,
        grid: false,
      }));
    }
  }, [
    appliedFilters.name,
    appliedFilters.source,
    appliedFilters.email,
    appliedFilters.city,
    appliedFilters.state,
    appliedFilters.zip,
    candidatesData.paginationModel.page,
    candidatesData.paginationModel.pageSize,
  ]);

  const handleApplyFilters = () => {
    const query = qs.stringify(
      {
        ...tempFormState,
        page: 1,
      },
      { skipNull: true, skipEmptyString: true }
    );
    setFormState(tempFormState);
    setAppliedFilters(tempFormState);
    navigate(`/candidates?${query}`);
    // setAppliedFilters({ ...formState });
    // fetchCandidatesGridData();
    handleClose();
  };

  const fetchCandidatesData = async () => {
    const payload = {
      tile_type: "candidate_count",
    };
    setLoading((prev) => ({
      ...prev,
      count: true,
    }));
    try {
      const response = await API.post("tiles/get-count", payload);
      const apiData = response.data.data;

      setCandidatesData((prevState) => ({
        ...prevState,
        countData: apiData,
      }));
    } catch (error) {
      console.error("Error fetching candidates data:", error);
    } finally {
      setLoading((prev) => ({
        ...prev,
        count: false,
      }));
    }
  };

  useEffect(() => {
    const queryParams = qs.parse(location.search);

    const { page = 1, name, source, email, city, state, zip } = queryParams;

    const filtersFromQuery = {
      name: name ? (Array.isArray(name) ? name : [name]) : null,
      source: source ? (Array.isArray(source) ? source : [source]) : null,
      email: email ? (Array.isArray(email) ? email : [email]) : null,
      city: city ? (Array.isArray(city) ? city : [city]) : null,
      state: state ? (Array.isArray(state) ? state : [state]) : null,
      zip: zip ? (Array.isArray(zip) ? zip : [zip]) : null,
    };

    setFormState(filtersFromQuery);
    setAppliedFilters(filtersFromQuery);

    setCandidatesData((prev) => ({
      ...prev,
      paginationModel: {
        ...prev.paginationModel,
        page: parseInt(page) - 1,
      },
    }));
  }, [location.search]);

  useEffect(() => {
    if (anchorEl && formState !== null) {
      const validEntries = Object.entries(formState).filter(
        ([_, value]) =>
          value !== null &&
          value !== undefined &&
          !(Array.isArray(value) && value.length === 0) &&
          value !== ""
      );

      if (validEntries.length === 0) return;

      const payload = validEntries.reduce((acc, [key]) => {
        acc[`${key}Search`] = "";
        return acc;
      }, {});

      fetchCandidateFilterData(payload);
    }
  }, [anchorEl]);

  useEffect(() => {
    fetchCandidatesData();
  }, []);

  useEffect(() => {
    fetchCandidatesGridData();
  }, [
    // candidatesData.paginationModel.pageSize,
    // candidatesData.paginationModel.page,
    // appliedFilters,
    fetchCandidatesGridData,
  ]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "16px",
        backgroundColor: "#E3F2FD",
        height: "100%",
        boxSizing: "border-box",
        borderRadius: "24px 0 0 0",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "16px",
          marginBottom: "16px",
          flexShrink: 0,
        }}
      >
        <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
          Candidates
        </Typography>

        {loading.count ? (
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "12px",
              flex: 1,
              textAlign: "center",
              padding: "16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100px",
            }}
          >
            <LoadingSpinner />
          </Box>
        ) : candidatesData.countData.length > 0 ? (
          <CountInfo sections={candidatesData.countData} showHeader={false} />
        ) : (
          <CountInfo sections={[]} showHeader={false} />
        )}
      </Box>
      <Box
        sx={{
          borderRadius: "12px",
          padding: "16px",
          backgroundColor: "white",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "16px",
            flexShrink: 0,
          }}
        >
          <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
            List of Candidates
          </Typography>

          <Box sx={{ display: "flex", gap: "12px" }}>
            <Button
              sx={{
                backgroundColor: "#2196F3",
                padding: "6px 10px",
                color: "white",
                display: "flex",
                alignItems: "center",
              }}
              variant="contained"
              onClick={() => setAddToJob(true)}
              disabled={selectedCandidateIds.length === 0}
            >
              <Typography sx={{ fontSize: "14px", color: "white" }}>
                ADD TO JOB
              </Typography>
            </Button>

            <AddCandidatePop
              isAddToJob={false}
              fetchCandidatesGridData={fetchCandidatesGridData}
            />
            <AddBulkCandidates
              pollStatus={pollStatus}
              setUploadProgress={setUploadProgress}
              setUploadingFiles={setUploadingFiles}
              setUploadPanelOpen={setUploadPanelOpen}
              setProcessedFiles={setProcessedFiles}
              isProcessing={isProcessing}
              setIsProcessing={setIsProcessing}
            />

            {candidatesData.showAllData && (
              <Button
                sx={{
                  backgroundColor: "#2196F3",
                  padding: "6px 10px",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                }}
                variant="contained"
                onClick={(e) => handleOpen(e)}
              >
                <FilterAltOutlinedIcon
                  sx={{ fontSize: 20, marginRight: "8px" }}
                />
                <Typography sx={{ fontSize: "14px" }}>FILTER</Typography>
              </Button>
            )}
          </Box>
        </Box>

        {selectionError && (
          <Typography
            sx={{ color: "red", marginBottom: "12px", fontSize: "14px" }}
          >
            {selectionError}
          </Typography>
        )}
        <Box sx={{ flex: 1, overflow: "hidden" }}>
          <DynamicDataGrid
            rows={candidatesData.listData.candidateDetails || []}
            showCheckbox={true}
            showSelectedCount={false}
            totalRows={candidatesData.listData.totalCandidates || 0}
            paginationModel={candidatesData.paginationModel}
            buttonName="candidate"
            onPaginationModelChange={(paginationModel) => {
              setCandidatesData((prevState) => ({
                ...prevState,
                paginationModel,
              }));
              navigate(
                `/candidates?${qs.stringify(
                  {
                    ...formState,
                    page: paginationModel.page + 1,
                  },
                  { skipNull: true, skipEmptyString: true }
                )}`
              );
            }}
            setShowAllData={setCandidatesData}
            // setOpenDialog={setOpenDialog}
            handleOpen={handleOpen}
            formatters={formatters}
            loading={loading.grid}
            onRowSelection={handleRowSelection}
            onRowSelectionModelChange={handleSelectionChange}
            rowSelectionModel={selectedCandidateIds}
          />
        </Box>
      </Box>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        // sx={{ pointerEvents: "none" }}
        disableRestoreFocus
      >
        <Box sx={{ padding: 2, width: 300 }}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Candidate Filter
          </Typography>
          <Divider sx={{ marginTop: 1 }} />
          {formConfigurations ? (
            <DynamicForm
              formData={formConfigurations}
              formState={tempFormState}
              handleChange={handleChange}
              debouncedFilterData={debouncedFetchCandidateFilterData}
              filterData={fetchCandidateFilterData}
            />
          ) : (
            <LoadingSpinner />
          )}
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", marginTop: 2 }}
          >
            <Button onClick={handleResetFilters}>Reset</Button>
            <Button variant="contained" onClick={handleApplyFilters}>
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>
      <AddToJob
        open={addTOJob}
        onClose={() => setAddToJob(false)}
        candidateId={selectedCandidateIds}
        setSnackbar={setSnackbar}
        onSuccessfulAdd={clearSelectedCandidateIds}
      />
      <CustomSnackbar
        open={snackbar.open}
        onClose={handleSnackbarClose}
        message={snackbar.message}
        severity={snackbar.severity}
      />
    </Box>
  );
}
export default Candidates;
